
import { RootState } from '../interfaces/rootState';
import { httpCommpix } from '@/util/HTTPCommpix';
import { SalesReportState, SalesReport } from '../interfaces/salesReport';
import { ActionContext } from 'vuex';
import { AxiosError } from 'axios';

const state: SalesReportState = {
  report: null,
  reportError: null,
};

const mutations = {
  setReport(state: SalesReportState, report: SalesReport | null): void {
    state.report = report;
  },
  setReportError(state: SalesReportState, error: string | null): void {
    state.reportError = error;
  },
};

const actions = {
  fetchSalesReport(
    { commit, }: ActionContext<SalesReportState, RootState>,
    {
      commerceId,
      branchId,
      companyId,
      username,
      showCompanyTransactions,
    }: {
      commerceId?: string;
      branchId?: string;
      companyId: string;
      username?: string;
      showCompanyTransactions?: boolean;
    }
  ): Promise<SalesReport> {
    commit('setReportError', null);
    return new Promise((resolve, reject) => {
      httpCommpix
        .post('/statistics', {
          companyId,
          ...(commerceId && { commerceId, }),
          ...(branchId && { branchId, }),
          ...(username && { username, }),
          ...(showCompanyTransactions !== undefined && { showCompanyTransactions, }),
        })
        .then((res) => {
          commit('setReport', res.data);
          resolve(res.data);
        })
        .catch((error: AxiosError) => {
          const errorMsg = error.response?.data?.message || 'Error al obtener el reporte';
          commit('setReportError', errorMsg);
          reject(error);
        });
    });
  },
};

const getters = {
  salesReport: (state: SalesReportState): SalesReport | null => state.report,
  salesReportError: (state: SalesReportState): string | null => state.reportError,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
